import React, { useState } from "react"

import { ResetPasswordForm } from "./Form"
import { ResetPasswordSubmittedScreenContent } from "./Submitted"

export const ResetPasswordScreenContent = () => {
  const [isSubmitted, setIsSubmitted] = useState(false)

  return <>
    {isSubmitted ? <ResetPasswordSubmittedScreenContent/> :
      <ResetPasswordForm executeOnSuccess={() => setIsSubmitted(true)}/>}
  </>
}
